import React, { useState } from "react";
import { useLegacy } from "../../lib/researchApi";
import { PapersPanel, PaperBriefModal } from "../arena/ResearcherPage";

export default function ResearchPapers() {
  const { data, error, loading, refreshing, reload } = useLegacy("/researcher/papers?limit=100");
  const [query, setQuery] = useState("");
  const [minimum, setMinimum] = useState(0);
  const [briefPaper, setBriefPaper] = useState(null);
  const papers = data?.papers || [];
  const failure = error || data?.error;
  const visible = papers.filter((p) =>
    (p.relevance_score ?? 0) >= minimum &&
    [p.title, p.arxiv_id, ...(p.authors || []), ...(p.themes || [])]
      .join(" ").toLowerCase().includes(query.trim().toLowerCase())
  ).map((p) => ({ ...p, relevance_score: p.relevance_score == null ? null : p.relevance_score / 100 }));

  return (
    <div className="rx-grid" style={{ gap: 14 }}>
      <section className="rx-card">
        <h2 className="rx-display" style={{ fontSize: 30, margin: "0 0 8px" }}>Papers</h2>
        <p className="rx-muted" style={{ margin: "0 0 16px", fontSize: 13 }}>
          AEON’s internal research and the latest 100 discovered papers. Read the original source or open an AEON integration brief.
        </p>
        <div className="rx-row" style={{ gap: 10 }}>
          <input aria-label="Search papers" placeholder="Search title, author, theme or arXiv ID…"
            value={query} onChange={(event) => setQuery(event.target.value)}
            className="rx-cell" style={{ flex: "1 1 240px", minWidth: 0, color: "var(--text)" }} />
          <label className="rx-muted" style={{ fontSize: 12 }}>
            Relevance{" "}
            <select value={minimum} onChange={(event) => setMinimum(Number(event.target.value))}
              className="rx-cell" style={{ color: "var(--text)" }}>
              {[0, 50, 70, 85].map((value) => <option key={value} value={value}>{value ? `${value}+` : "All"}</option>)}
            </select>
          </label>
          <button type="button" className="rx-chip" onClick={reload} disabled={loading || refreshing}>
            {refreshing ? "Refreshing…" : "Refresh"}
          </button>
        </div>
        <p className="rx-faint" aria-live="polite" style={{ fontSize: 12, marginBottom: 0 }}>
          {loading || !data && !failure ? "Loading papers…" : `${visible.length} of ${papers.length} discovered papers shown · internal paper pinned below`}
        </p>
        {failure && <div role="alert" className="rx-empty" style={{ marginTop: 12 }}>
          Papers could not be refreshed. {papers.length > 0 ? "Showing the last loaded papers. " : ""}
          Use Refresh to try again.
        </div>}
        {!loading && !failure && papers.length > 0 && visible.length === 0 &&
          <div className="rx-empty" style={{ marginTop: 12 }}>No papers match these filters.</div>}
      </section>
      <PapersPanel papers={visible} onBrief={setBriefPaper} showEmpty={Boolean(data) && !failure && papers.length === 0} />
      {briefPaper && <PaperBriefModal paper={briefPaper} onClose={() => setBriefPaper(null)} />}
    </div>
  );
}
